import React from 'react';
import { t } from '../../i18n';
import './style.scss';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="privacy-policy-container">
      <h2>{t('ppTitle')}</h2>
      <p className="last-updated">{t('ppLastUpdated')}</p>

      <section>
        <h3>{t('ppSection1Title')}</h3>
        <p>{t('ppSection1Body')}</p>
      </section>

      <section>
        <h3>{t('ppSection2Title')}</h3>
        <p>{t('ppSection2Body')}</p>
        <ul>
          <li><strong>{t('ppSection2Item1Title')}</strong>: {t('ppSection2Item1Body')}</li>
          <li><strong>{t('ppSection2Item2Title')}</strong>: {t('ppSection2Item2Body')}</li>
        </ul>
      </section>

      <section>
        <h3>{t('ppSection3Title')}</h3>
        <p>{t('ppSection3Body')} <strong>{t('ppSection3Bold')}</strong></p>
        <ul>
          <li>{t('ppSection3Item1')}</li>
          <li>{t('ppSection3Item2')}</li>
        </ul>
      </section>

      <section>
        <h3>{t('ppSection4Title')}</h3>
        <ul>
          <li>{t('ppSection4Item1')}</li>
          <li>{t('ppSection4Item2')}</li>
        </ul>
      </section>

      <section>
        <h3>{t('ppSection5Title')}</h3>
        <p>{t('ppSection5Body')}</p>
      </section>

      <section>
        <h3>{t('ppSection6Title')}</h3>
        <ul>
          <li><strong>{t('ppSection6Item1Title')} (<code>&lt;all_urls&gt;</code>)</strong>: {t('ppSection6Item1Body')}</li>
          <li><strong>{t('ppSection6Item2Title')} (<code>storage</code>)</strong>: {t('ppSection6Item2Body')}</li>
          <li><strong>{t('ppSection6Item3Title')} (<code>tabs</code>)</strong>: {t('ppSection6Item3Body')}</li>
        </ul>
      </section>

      <section>
        <h3>{t('ppSection7Title')}</h3>
        <p>{t('ppSection7Body')}</p>
        <ul>
          <li>{t('ppSection7Item1')}</li>
          <li>{t('ppSection7Item2')}</li>
          <li>{t('ppSection7Item3')}</li>
        </ul>
      </section>

      <section>
        <h3>{t('ppSection8Title')}</h3>
        <p>{t('ppSection8Body')}</p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
